/**
 * Tope de humedad de la sonda Xiaoma.
 *
 * YaTun lo confirmó por escrito el 2026-09-01: cuando el cálculo interno pasa
 * de 99 %, el firmware **reporta 99 % y ya**. O sea que un 99 no significa
 * "99 % de humedad", significa "99 % o más" — y no hay manera de saber si
 * detrás hay un 101 o un 140, porque el valor crudo se queda dentro del
 * equipo y sólo sale por el conector 485.
 *
 * Mostrarlo como "99.0 %" lo hace indistinguible de una medición normal, que
 * es justo el problema: en el piloto de Leyer cinco de siete capas están
 * topadas y se leían como si el suelo estuviera casi saturado en todas.
 *
 * Se marca con "≥" en lugar de esconderlo o inventar otra cosa: el número
 * sigue siendo el que reportó el equipo, sólo que dice lo que de verdad
 * significa. La causa es de calibración de fábrica contra el suelo del sitio,
 * y se corrige con el hardware de calibración, no en la plataforma.
 */
export const HUMEDAD_TOPE = 99;

/** ¿Esta lectura está pegada al tope del sensor? */
export function esTopeDeSensor(paramKey: string, value: number | null | undefined): boolean {
  return paramKey === 'humidity'
    && typeof value === 'number'
    && Number.isFinite(value)
    && value >= HUMEDAD_TOPE;
}

/**
 * Formatea una lectura para mostrarla, anteponiendo "≥" cuando está topada.
 *
 * @returns "—" si no hay dato. Nunca 0: un cero es una medición, la ausencia
 *          de dato no lo es.
 */
export function formatLectura(
  paramKey: string,
  value: number | null | undefined,
  decimales = 1,
): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return `${esTopeDeSensor(paramKey, value) ? '≥' : ''}${value.toFixed(decimales)}`;
}
